export default __webpack_public_path__ + "static/media/logo-1lynk.d4ba9f1e.svg";